module.exports = __webpack_public_path__ + "img/gift12.8c2d2de6.png";